import { useEffect } from "react";

const CANONICAL_ORIGIN = process.env.REACT_APP_CANONICAL_ORIGIN;
const DEFAULT_IMAGE = `${CANONICAL_ORIGIN}/images/home/financial-district.jpg`;

const setMeta = (name, content, property = false) => {
  const attribute = property ? "property" : "name";
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const removeMeta = (name, property = false) => {
  const attribute = property ? "property" : "name";
  document.head.querySelector(`meta[${attribute}="${name}"]`)?.remove();
};

export const PageMeta = ({ title, description, path, type = "website", image = DEFAULT_IMAGE, imageAlt = "FU Research", publishedAt, modifiedAt, schema, robots = "index, follow" }) => {
  const canonical = `${CANONICAL_ORIGIN}${path === "/" ? "/" : path}`;
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("robots", robots);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", type, true);
    setMeta("og:url", canonical, true);
    setMeta("og:site_name", "FU Research", true);
    setMeta("og:image", image, true);
    setMeta("og:image:alt", imageAlt, true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", image);
    setMeta("twitter:image:alt", imageAlt);
    if (publishedAt) setMeta("article:published_time", publishedAt, true);
    else removeMeta("article:published_time", true);
    if (modifiedAt) setMeta("article:modified_time", modifiedAt, true);
    else removeMeta("article:modified_time", true);

    let canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);

    document.getElementById("page-structured-data")?.remove();
    if (schema) {
      const script = document.createElement("script");
      script.id = "page-structured-data";
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [canonical, description, image, imageAlt, modifiedAt, publishedAt, robots, schema, title, type]);

  if (typeof window === "undefined") {
    const payload = JSON.stringify({ title, description, canonical, type, image, imageAlt, publishedAt, modifiedAt, robots, schema }).replace(/</g, "\\u003c");
    return <script id="static-page-meta" type="application/json" dangerouslySetInnerHTML={{ __html: payload }} />;
  }

  return null;
};